import { MdAreaChart, MdExplore, MdSimCard, MdOutlineKeyboardArrowLeft } from 'react-icons/md';
import { BsFillLaptopFill } from "react-icons/bs";
import { MdCall } from "react-icons/md";
import { MdStorefront } from "react-icons/md";
import { IoIosSettings } from 'react-icons/io';

export const admin = [
  {
    title: 'Explore',
    path: '/home',
    icon: <MdExplore size={28}/>,
    cName: 'nav-item',
  },
  {
    title: 'Reseller',
    path: '/reseller',
    icon: <MdStorefront size={28}/>,
    cName: 'nav-item',
  
  },
  {
    title: 'Sim Overview',
    icon: <MdSimCard size={28}/>,
    cName: 'nav-item',
    toggle: <MdOutlineKeyboardArrowLeft size={28}/>,
    subNav: [
          {
            title: 'Overview',
            path: '/overview',
            cName: 'nav-item-submenu',
          },
          {
            title: 'Manage Sims',
            path: '/manage',
            cName: 'nav-item-submenu',
          }
        
        
        
        ]
  },
  {
    title: 'KPI-Portal',
    icon: <MdAreaChart size={28} />,
    cName: 'nav-item',
    toggle: <MdOutlineKeyboardArrowLeft size={28} />, 
    subNav: [
      {
        title: 'Athalos',
        path: '/portal-athalos',
        cName: 'nav-item-submenu',
      },
      {
        title: 'OWN',
        path: '/portal-own',
        cName: 'nav-item-submenu',
      },
      {
        title: 'Prs',
        path: '/portal-prs',
        cName: 'nav-item-submenu',
      },
    ],
  },
      

  {
    title: 'App Features',
    icon: <MdCall size={28} />,
    cName: 'nav-item',
    toggle: <MdOutlineKeyboardArrowLeft size={28} />, 
    subNav: [
      {
        title: 'Added Services',
        path: '/value-added-services',
        // icon: <BsFillLaptopFill size={28}/>,
        cName: 'nav-item-submenu',
      },

      {
        title: 'Messages',
        path: '/messages',
        // icon: <MdSms size={28} />,
        cName: 'nav-item-submenu',
      },
      
      {
        title: 'VoiP',
        path: '/voip',
        // icon: <MdCall size={28} />,
        cName: 'nav-item-submenu',
      },
    
      {
        title: 'SMS',
        path: '/sms',
        // icon: <MdSms size={28} />,
        cName: 'nav-item-submenu',
      },

      {
        // COMMENT OLAV THIS DOESNT WORK
        title: 'Translator',
        path: '/messages',
        // icon: <MdSms size={28} />,
        cName: 'nav-item-submenu',
      },

    ],
  },

];


export const reseller = [
  {
    title: 'Explore',
    path: '/home',
    icon: <MdExplore size={28}/>,
    cName: 'nav-item',
  },
  {
    title: 'Reseller',
    path: '/reseller',
    icon: <MdStorefront size={28}/>,
    cName: 'nav-item',
  
  },
  {
    title: 'Value Added Services',
    path: '/value-added-services',
    icon: <BsFillLaptopFill size={28}/>,
    cName: 'nav-item',
  },
]
export const TT = [
  {
    title: 'Explore',
    path: '/home',
    icon: <MdExplore size={28}/>,
    cName: 'nav-item',
  },
  {
    title: 'Reseller',
    path: '/reseller',
    icon: <MdStorefront size={28}/>,
    cName: 'nav-item',
  
  },
  {
    title: 'Value Added Services',
    path: '/value-added-services',
    icon: <BsFillLaptopFill size={28}/>,
    cName: 'nav-item',
  },
]






export const resellerAccount = [ // DYNAMIC for Feedback// = (currentPage) => [

  // {
  //   title: 'Settings',
  //   path: '/settings',
  //   icon: <IoIosSettings size={28}/>,
  //   cName: 'nav-item-settings'
  // }
];

export const adminAccount = [ // DYNAMIC for Feedback// = (currentPage) => [
  {
    title: 'Settings',
    path: '/settings',
    icon: <IoIosSettings size={28}/>,
    cName: 'nav-item-settings'
  }
];

export const newUser = [
  {
    title: 'Explore',
    path: '/home',
    icon: <MdExplore size={28}/>,
    cName: 'nav-item',
  }

]
